module.exports = __webpack_public_path__ + "img/logo-eng (2).789cb656.png";